module.exports = __webpack_public_path__ + "media/images/philanthropy-logos/logo-fa-a6c2f5ab1b9d8e479f5b401d71e5c470.svg";